import { useCallback, useState } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { AiAssistantMainMenuTileItemSummaryModal } from './AiAssistantMainMenuTileItemSummaryModal';
import type {
   AiAssistantMainMenuTileItemSummaryModalAcceptSummaryCallback,
   AiAssistantMainMenuTileItemSummaryModalOpenCallback,
   AiAssistantMainMenuTileItemSummaryModalResult,
} from './AiAssistantMainMenuTileItemSummaryModal.types';

type SummaryState = { result: AiAssistantMainMenuTileItemSummaryModalResult; accumulatedSeconds: number };

type AiAssistantMainMenuTileItemSummaryModalOpenerRenderProps = {
   openModal: AiAssistantMainMenuTileItemSummaryModalOpenCallback;
};

type AiAssistantMainMenuTileItemSummaryModalOpenerProps = {
   children: (renderProps: AiAssistantMainMenuTileItemSummaryModalOpenerRenderProps) => JSX.Element;
   onAcceptSummary: AiAssistantMainMenuTileItemSummaryModalAcceptSummaryCallback;
};

export const AiAssistantMainMenuTileItemSummaryModalOpener = (
   props: AiAssistantMainMenuTileItemSummaryModalOpenerProps
): JSX.Element => {
   const [summary, setSummary] = useState<SummaryState>({ result: null, accumulatedSeconds: 0 });
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   const handleOpenModal = useCallback<AiAssistantMainMenuTileItemSummaryModalOpenCallback>(
      (result, accumulatedSeconds) => {
         if (result !== undefined) {
            setSummary({ result: result, accumulatedSeconds: accumulatedSeconds ?? 0 });
         }

         openModal();
      },
      [openModal]
   );

   return (
      <>
         {props.children({ openModal: handleOpenModal })}

         {modalOpened ? (
            <AiAssistantMainMenuTileItemSummaryModal
               result={summary.result}
               accumulatedSeconds={summary.accumulatedSeconds}
               onClose={closeModal}
               onAcceptSummary={props.onAcceptSummary}
            />
         ) : null}
      </>
   );
};
